import React, { useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IconUiSad } from '@uberall/zenit';
import classnames from 'classnames';

import styles from './index.module.css';
import sharedStyles from '../../sharedStyles.module.css';
import Footer from '../footer';
import { RequestAccessFormContext } from '../../contexts/request-access-form-context';
import Stepper from '../stepper/stepper';
import Message from '../Message';
import { MainContentContainer } from '../main-content-container';

const ErrorView = () => {
    const navigate = useNavigate();
    const { step, setStep } = useContext(RequestAccessFormContext);
    const { accessId } = useParams();

    const handleGoBack = () => {
        setStep(0);
        navigate(`/${accessId}`);
    };

    const hasStepper = step > 0;

    return (
        <>
            {hasStepper && (
                <Stepper
                    label="app.request.access.public.error.navbar.label"
                    onClose={handleGoBack}
                />
            )}
            <MainContentContainer
                className={classnames(styles.container, {
                    [styles.containerWithoutStepper]: !hasStepper,
                })}
            >
                <div className={styles.headline}>
                    <h1 className={sharedStyles.textHeadline}>
                        <Message code="app.request.access.public.error.title"></Message>
                    </h1>
                    <IconUiSad className={styles.iconHeadline} />
                </div>
                <Message code="app.request.access.public.error.try.again"></Message>
            </MainContentContainer>
            <Footer
                buttonLabel="app.request.access.public.error.submit.button"
                buttonProps={{ onClick: handleGoBack }}
                // we don't want to show the footer links on the error page because we get them from the API that is throwing the error
                showFooterLinks={false}
            />
        </>
    );
};

export default ErrorView;
